import styled, { css } from 'styled-components';

const greyColor = '#E8E8E8';
const redColor = '#FF3F4F';

const shadowEnableButton = css`
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.08);
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FormElCssReset = css`
  background: none;
  border: none;
  outline: none;
`;

const FontSettings = css`
  font-size: 14px;
  line-height: 16px;
`;

const contentInput = css`
  ${FontSettings}
  width: 100%;
  text-align: center;
  color: ${({ theme, $error }) => ($error ? redColor : theme.grey.darker)};
`;

const Button = styled(FlexContainer)`
  ${FormElCssReset}
  cursor: pointer;
  width: 36px;
  min-width: 36px;
  height: 34px;
  border-radius: 8px;
  background: #fff;
`;

export const Container = styled(FlexContainer)`
  flex-direction: column;
  margin-top: 24px;
  margin-bottom: -4px;
  @media screen and (min-width: 768px) {
    margin-top: -6px;
    margin-bottom: ${({ $error }) => (!$error ? '16px' : '0')};
  }

  label {
    ${FontSettings}
    color: ${({ theme }) => theme.grey.dark};
    font-weight: bold;
    margin-bottom: 4px;
  }
`;

export const Wrapper = styled(FlexContainer)`
  width: 200px;
  border: 1.4px solid ${({ $error }) => ($error ? redColor : greyColor)};
  border-radius: 8px;
  background: #fafafa;
  ${({ $error }) =>
    $error &&
    `
    animation: shake 0.1s;
    animation-iteration-count: 3;

    @keyframes shake {
      0% {margin-left: 0;}
      25% {margin-left: 5px;}
      50% {margin-left: 0;}
      75% {margin-left: -5px;}
      100% {margin-left: 0;}
    }
  `};
`;

export const MinusButton = styled(Button)`
  border-right: 1.4px solid ${greyColor};
  ${({ $disableMinus }) => css`
    ${$disableMinus && 'pointer-events: none;'}
    ${!$disableMinus && shadowEnableButton}
  `}

  svg {
    width: 11px;
    height: 1px;

    path {
      fill: ${({ theme, $disableMinus }) => ($disableMinus ? greyColor : theme.grey.darker)};
    }
  }
`;

export const PlusButton = styled(Button)`
  border-left: 1.4px solid ${greyColor};
  ${({ $disablePlus }) => css`
    ${$disablePlus && 'pointer-events: none;'}
    ${!$disablePlus && shadowEnableButton}
  `}

  svg {
    width: 11px;
    height: 11px;

    path {
      fill: ${({ $disablePlus }) => ($disablePlus ? greyColor : redColor)};
    }
  }
`;

export const InputQty = styled.input`
  ${contentInput}
  ${({ $editing }) => !$editing && 'max-width: 0px;'}
  -moz-appearance: textfield;
  background: #fafafa;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ${FormElCssReset}
`;

export const ErrorMessage = styled.p`
  ${FontSettings}
  color: ${redColor};
  text-align: center;
  margin-top: 10px;
  margin-bottom: -4px;
  @media screen and (min-width: 768px) {
    margin-bottom: 16px;
  }
`;

export const InputQtyDescription = styled.div`
  ${contentInput}
`;
